export default __webpack_public_path__ + "static/media/over-axle-axlesGroup.ab98cc3e.svg";